import './App.scss';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import InboxPage from './pages/InboxPage/InboxPage'
import RequestsPage from './pages/RequestsPage/RequestsPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import ArrivalsPage from './pages/ArrivalsPage/ArrivalsPage';
import ReviewsPage from './pages/ReviewsPage/ReviewsPage';
import LeadsPage from './pages/LeadsPage/LeadsPage';
import { useState, useEffect } from 'react';
import axios from 'axios';
import loadingSpinner from './assets/eclipse-1s-200px.gif'
import toast, { Toaster } from 'react-hot-toast';
import { io } from "socket.io-client";

function App() {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [chatToken, setChatToken] = useState();
  const [hotelId, setHotelId] = useState();
  const [webSocket, setWebSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [leadsPageDisabled, setLeadsPageDisabled] = useState(true)
  const [reviewsPageDisabled, setReviewsPageDisabled] = useState(true);
  const [hotelData, setHotelData] = useState(null);
  const disabledPagesObj = {leadsPageDisabled, reviewsPageDisabled};
  const hotel = localStorage.getItem('marie_hotel_id');

  const parseHash = () => {
    var hash = window.location.hash.substring(1);
    var params = {}
    hash.split('&').map(hk => { 
      let temp = hk.split('='); 
        params[temp[0]] = temp[1] 
    });
    return params
  }

  useEffect(() => {
    let hotelData = null;
    async function getHotelData() {
      try{
        const url = `/api/hotel/${hotel}/hotel-data`;
        const response = await axios.get(url);
        hotelData = response?.data?.hotelData
        setHotelData(hotelData);
        const leadsLocked = hotelData?.LeadsPageDisabled;
        const reviewsLocked = hotelData?.ReviewsPageDisabled;
        setLeadsPageDisabled(leadsLocked == 'undefined' ? true : leadsLocked);
        setReviewsPageDisabled(reviewsLocked == 'undefined' ? true : reviewsLocked);
        return hotelData;
      }catch(error){
        console.error("Failed to get the leads page disabled status", error)
      }
    }
    getHotelData();
  },[hotel])

  useEffect(() => {
    async function redirectUrls(){
      const urlList = JSON.parse(process.env.REACT_APP_REDIRECT_URLS);
        for (const ending in urlList){
          if(window.location.href.endsWith(ending)){
            window.location.href = urlList[ending];
          }
        }
    }
    async function fetchData() {
      // await redirectUrls();
      const params = parseHash()
      let access_token
      let id_token
      console.log("params", params);
      if (params.id_token){
        id_token = params.id_token;
      }
      if (params.access_token) {
        access_token = params.access_token
        localStorage.setItem('marie_access_token', access_token)
      } else {
        access_token = localStorage.getItem('marie_access_token', access_token)
      }
      try {
        const response = await axios.post('/api/auth/login', {
          access_token: access_token,
          id_token: id_token
        });
        if (response.status == 200) {
          setAuthenticated(true)
          setChatToken(response.data.chatToken)
          setHotelId(response.data.hotelId)
          localStorage.setItem('marie_hotel_id', response.data.hotelId);
          try {
            const hotel = localStorage.getItem('marie_hotel_id');
            const response = await axios.get(`/api/hotel/${hotel}/phone-number`);
            localStorage.setItem('marie_hotel_phone_number', response.data.hotelPhoneNumber)
          } catch (error) {
            console.error(error)
          }
        }
        const url = axios.defaults.baseURL + "?hotelId=" + localStorage.getItem('marie_hotel_id');
        const socket = await new io(url, { transports: ['websocket'] });
        socket.on("connect", () => {
        });
        socket.on("connect_error", (err) => {
          console.log("Connect error:", err);
        });
        setWebSocket(socket);
        setIsConnected(true);
      } catch (error) {
        if (error.response.status == 403) {
          window.location.href = error.response.data.redirectUrl
        }
      }
    }
    fetchData();

    return () => {
      webSocket.disconnect();
    }
  }, []);


  return (
    <div className="app-body">
      <Toaster toastOptions={{
          className: 'reminder-toast',
      }}/>
      {isAuthenticated && isConnected ?
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Navigate to="/requests" /> }/>
          <Route path="inbox" element={<InboxPage chatToken={chatToken} hotelId={hotelId} socket={webSocket} disabledPages={disabledPagesObj}></InboxPage>} />
          <Route path="reviews" element={<ReviewsPage chatToken={chatToken} hotelId={hotelId} disabledPages={disabledPagesObj} hotelData={hotelData}></ReviewsPage>}/>
          <Route path="requests" element={<RequestsPage chatToken={chatToken} hotelId={hotelId} socket={webSocket} disabledPages={disabledPagesObj} hotelData={hotelData}></RequestsPage>}/>
          <Route path="leads" element={<LeadsPage chatToken={chatToken} hotelId={hotelId} disabledPages={disabledPagesObj}></LeadsPage>} />
          <Route path="settings" element={<SettingsPage chatToken={chatToken} hotelId={hotelId} disabledPages={disabledPagesObj}></SettingsPage>} />
          <Route path="arrivals" element={<ArrivalsPage chatToken={chatToken} hotelId={hotelId} disabledPages={disabledPagesObj}></ArrivalsPage>} />
        </Routes>
      </BrowserRouter> :
      <div className="loading-container">
        <img src={loadingSpinner} className="loading-spinner"></img>
      </div>}
    </div>
  );
}

export default App;
